import React, {useEffect, useMemo, useState} from 'react';
import {ArrowLeft, Users, Plus, Minus} from 'lucide-react';
import {Employee, EmployeeService, Service} from "../../types";
import {useBook} from "../useBook";
import {FloatingServiceSummary} from "../../components/floatingServiceSummary/FloatingServiceSummary";
import {useBookStaff} from "../bookStaff/useBookStaff";
import {useQuery} from "../../utils/useQuery";
import placeholderProverImg from "app/assets/images/ph1.jpg";
import {toast} from "react-toastify";
import {Avatar} from "../../components/avatar/avatar";
import {format} from "date-fns";
import {useChangeService} from "../utils/useChangeService";

interface ProviderSelectionProps {
    onBack: () => void;

}

export const ProviderSelection = () => {
    const query = useQuery()
    const {
        serviceProviders,
        isLoading,
        getNextAvailabilityDay,
        account,
        selectedServiceProvider,
        onServiceProviderClick,
        cart,
        navigateToService,
        navigateToTime,
        appointmentGroupToReschedule,
        onRemoveMerchantService,
        additionalServicesWithProvider,
        onAdditionalServicePress,
        expandedAdditionalServiceProviderId,
        setExpandedAdditionalServiceProviderId,
        groupedMerchantServices,
        selectedServiceId,
        availableAddonServices,
        selectedService,
        selectedAddonServices,
        allSelectedServices,
        selectedAddons,
        setSelectedAddons,
        isSlotFlow,
        isCheckingSlotAvailability,
        hasNoAvailableProvidersForSlot,
        finalizeSlotBooking,
        showDualPricingModal,
        setShowDualPricingModal,
        onDualPricingPayBy,

    } = useBookStaff();

    const slotDate = query.get("date");
    const slotTime = query.get("time");
    const changeService = useChangeService();


    useEffect(() => {
        console.log('selected in cart-', cart.merchantServices)
        console.log('cart--', cart)
        console.log('merchant services', groupedMerchantServices)
        console.log('selected query', query)
        console.log('selected grouped', groupedMerchantServices)
        console.log(' availableAddonServices ', availableAddonServices)
        console.log(' selected servioce', selectedService)
    }, [selectedService, selectedServiceProvider]);


    const practitioners = useMemo(() => account.employees, [account])
    const services = useMemo(() => account.employees, [account])


    const handleAddonToggle = async (addon: EmployeeService) => {

        console.log('services of selected pro', services, selectedServiceProvider.services)

        const isSelected = allSelectedServices.some((a: any) => a.id === addon.id);
        const isInCart = cart.merchantServices.some((a: any) => a.id === addon.id);

        console.log('isInCart', isInCart)

        try {

            let newAddons: EmployeeService[];
            if (isSelected) {
                await onRemoveMerchantService(addon)

                newAddons = selectedAddons.filter(a => a.id !== addon.id);
            } else {
                await onAdditionalServicePress(addon)

                newAddons = [...selectedAddons, addon];
            }

            setSelectedAddons(newAddons);
        } catch (error: any) {
            toast.error(error.code || error.message);


        }


    };

    const handleNext = () => {
        if (isSlotFlow) {
            finalizeSlotBooking();
        } else {
            navigateToTime();
        }
    };

    const navigateBack = isSlotFlow ? navigateToTime : navigateToService;

    const availablePractitioners = serviceProviders


    useEffect(() => {
        console.log('service providers', serviceProviders)
        console.log('selected', selectedServiceProvider)
        console.log('additionalServicesWithProvider', additionalServicesWithProvider)
    }, [selectedServiceProvider]);

    return (
        <div className="w-full min-h-screen bg-slate-50 flex flex-col items-center">
            <div className="bg-white border-b border-slate-200 px-4 py-4 w-full">
                <div className="flex items-center gap-3 max-w-4xl mx-auto">
                    <button
                        onClick={navigateBack}
                        className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5"/>
                    </button>
                    <div className="flex-1 text-center">
                        <h1 className="text-lg font-semibold text-slate-900">Select Provider</h1>
                        <p className="text-sm text-slate-600">
                            {selectedService?.title}
                            {/* The main service has no remove button below (only add-ons do) */}
                            <button
                                onClick={changeService}
                                className="ml-2 text-xs font-medium text-blue-600 hover:text-blue-700"
                            >
                                Change
                            </button>
                        </p>
                        {isSlotFlow && slotDate && slotTime && (
                            <p className="text-xs text-slate-500">
                                {format(new Date(`${slotDate}T00:00:00`), "eee, MMM d")} at {slotTime}
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <div className="p-4 space-y-6 w-full max-w-4xl">
                {/* Provider Selection */}
                <div>
                    <h2 className="text-lg font-semibold text-slate-900 mb-4 text-center">
                        {isSlotFlow ? "Available At This Time" : "Choose Your Provider"}
                    </h2>
                    {isSlotFlow && isCheckingSlotAvailability ? (
                        <p className="text-center text-sm text-slate-500 py-6">Checking who's free...</p>
                    ) : hasNoAvailableProvidersForSlot ? (
                        <div className="text-center py-6 space-y-3">
                            <p className="text-sm text-slate-600">No staff are available at this time.</p>
                            <button
                                onClick={navigateToTime}
                                className="text-sm font-medium text-blue-600 hover:text-blue-700"
                            >
                                Choose another time
                            </button>
                        </div>
                    ) : (
                    <div className="grid grid-cols-2 gap-3">
                        {serviceProviders.map((practitioner) => (
                            <div
                                key={practitioner.id}
                                onClick={() => onServiceProviderClick(practitioner)}
                                className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                                    selectedServiceProvider?.id === practitioner.id
                                        ? 'border-blue-500 bg-blue-50'
                                        : 'border-slate-200 bg-white hover:border-slate-300'
                                }`}
                            >
                                <div className="flex items-center gap-3">


                                    {practitioner?.avatar ?
                                        <img
                                            src={practitioner?.avatar}
                                            alt={'provider'}
                                            // className="w-full h-full object-cover"
                                            className="w-12 h-12 rounded-full object-fill"
                                        />
                                        :
                                        <Avatar
                                            type={'character'}
                                            src={''}
                                            size={54}
                                            name={practitioner.name}
                                        />
                                    }

                                    <div className="flex-1">
                                        <h3 className="font-medium text-slate-900">{practitioner.name}</h3>
                                        {/*<p className="text-xs text-slate-600 mb-2 leading-relaxed">{practitioner.bio}</p>*/}
                                        {practitioner.services.find((service) => service.businessService.id === +selectedServiceId!) !== undefined && (
                                            <div className="text-sm mt-1 font-medium text-blue-600">
                                                {practitioner.services.find((service) => service.businessService.id === +selectedServiceId!)?.price}

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    )}
                </div>

                {/*Add-on Services */}
                {selectedServiceProvider && (
                    <div>
                        <h2 className="text-lg font-semibold text-slate-900 mb-4 text-center">Add-on Services</h2>
                        <div className="grid grid-cols-2 gap-3">
                            {availableAddonServices.map((addon: EmployeeService) => {
                                console.log('add on', addon)
                                const isSelected = allSelectedServices.some(a => a.id === addon.id);
                                // const addonPrice = selectedServiceProvider.services[addon.id].price || addon.price;
                                // const addonPrice = 100
                                return (
                                    <div
                                        key={addon.id}
                                        onClick={() => handleAddonToggle(addon)}
                                        className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                                            isSelected
                                                ? 'border-blue-500 bg-blue-50'
                                                : 'border-slate-200 bg-white hover:border-slate-300'
                                        }`}
                                    >
                                        <div className="flex items-start justify-between">
                                            <div className="flex-1">
                                                <h3 className="font-medium text-slate-900 mb-1">{addon.title}</h3>
                                                <p className="text-sm text-slate-600 mb-2">{addon.description}</p>
                                                <div className="flex items-center gap-4 text-sm text-slate-500">
                                                    <span>{addon.duration} min</span>
                                                    <span className="font-medium text-blue-600">{addon.price}</span>
                                                </div>
                                            </div>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddonToggle(addon);
                                                }}
                                                className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${
                                                    isSelected
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
                                                }`}
                                            >
                                                {isSelected ? <Minus className="w-4 h-4"/> :
                                                    <Plus className="w-4 h-4"/>}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Add bottom padding for floating popup */}
                <div className="h-24"></div>
            </div>

            {/* Floating Service Summary */}
            <FloatingServiceSummary
                selectedService={selectedService}
                selectedAddonServices={selectedAddons}
                selectedPractitioner={selectedServiceProvider}
                onNext={handleNext}
                // onRemoveAddon={(addonId) => {
                //     const addon = selectedAddons.find(a => a.id === addonId);
                //     if (addon) {
                //         handleAddonToggle(addon);
                //     }
                // }}
                showNextButton={!!selectedServiceProvider}
            />

        </div>
    );
};
